import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
const v = new Vue()
let permisson = false
const apiUrl = process.env.VUE_APP_API
const pageBaseUrl = process.env.BASE_URL
const service = axios.create({
  baseURL: apiUrl, // api 的基础地址
  timeout: 30000,
  withCredentials: true
})
function showModel () {
  permisson = true
  v.$bvModal.msgBoxOk('该用户没有权限')
    .then(value => {
      console.log(value)
    })
    .catch(err => {
      console.log(err)
    })
}
/* ***** request拦截器==>对请求参数做处理 ******/
service.interceptors.request.use(request => {
  console.log(request, '++++++')
  request.transformRequest = [transformRequest]
  return request
}, error => {
  console.log('error')
  Promise.reject(error)
})
const downloadUrl = url => {
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = url
  iframe.onload = function () {
    document.body.removeChild(iframe)
  }
  document.body.appendChild(iframe)
}
function transformRequest (data, headers) {
  var type = headers['Content-Type']
  if (type === undefined || type === 'application/x-www-form-urlencoded') {
    data = qs.stringify({ ...data }, { arrayFormat: 'repeat' })
  } else if (type === 'application/json;charset=UTF-8') {
    data = JSON.stringify(data)
  }
  return data
}
/** **** respone拦截器==>对响应做处理 ******/
service.interceptors.response.use(

  response => {
    if (response.headers && (response.headers['content-type'] === 'application/ms-excel;charset=UTF-8')) {
      downloadUrl(response.request.responseURL)
      response.data = ''
      // response.headers['content-type'] = 'text/json'
      return response
    }
    if (response.data.code === '1000') { // 未登陆用户跳转到登陆页面
      location.replace(pageBaseUrl + 'login.html')
    } else if (response.data.code === '1004') {
      // 没有权限
      if (permisson) {
        return
      } else { showModel() }
    }
    if (response.data) {
      return response.data
    }
    return response
  },
  error => { // 响应错误处理)
    console.log(JSON.stringify(error))
    const text = JSON.parse(JSON.stringify(error)).status === 404
      ? '404'
      : error + '网络异常，请重试'
    console.log(text)
    return Promise.reject(error)
  }
)
export default service
export { apiUrl as baseURL }
